module.exports = __webpack_public_path__ + "static/media/hired-banner-mobile.9fe724fa.png";